import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import ChangeOfficePassword                         from "../../../application/usecase/office/ChangeOfficePassword";
import GetOffice                                    from "../../../application/usecase/office/GetOffice";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import PasswordChangeButton                         from "../../components/common/PasswordChangeButton";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import OfficeSettingForm                            from "../../components/setting/office/OfficeSettingForm";
import OfficeUpdateButton                           from "../../components/setting/office/OfficeUpdateButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  getOffice: GetOffice;
  changeOfficePassword: ChangeOfficePassword;
}

class OfficeContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "事業所情報"
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.getOffice.execute();
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "事業所情報",
                path: "/office"
              },
            ]
          }/>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </TopSection>

        <TopSection>
          <OfficeUpdateButton/>
          <PasswordChangeButton
            onClick={ (currentPassword, newPassword, confirmPassword, callback) => this.props.changeOfficePassword.execute(currentPassword, newPassword, confirmPassword, callback) }
          />
          <BackHistoryButton path="/setting"/>
        </TopSection>

        <OfficeSettingForm/>

        <BottomSection>
          <OfficeUpdateButton/>
          <BackHistoryButton path="/setting"/>
        </BottomSection>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getOffice: new GetOffice(dispatch),
  changeOfficePassword: new ChangeOfficePassword(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfficeContainer);